import React from "react";

// STEP ICONS (apne actual icons ka path yahan rakho)
import step1 from "../../../assets/image/aboiocn.png";
import step2 from "../../../assets/image/aboutrue.png";
import step3 from "../../../assets/image/pilene.png";

const stepsData = [
  {
    step: "Step 1",
    title: "Client Consultation: ",
    desc: "Trinity will fill up all your required forms when you apply for a. ",
    icon: step1,
  },
  {
    step: "Step 2",
    title: "Referral to Licensed Legal Professionals: ",
    desc: "Trinity facilitates communication and document coordination between clients and independently licensed lawyers. All submissions are handled by authorized representatives where required.",
    icon: step2,
  },
  {
    step: "Step 3",
    title: "Administrative Assistance:  ",
    desc: "Don’t worry about  processing, just relax and wait to receive your desired .",
    icon: step3,
  },

  {
    step: "Step 4",
    title: "File Coordination And Case Management:",
    desc: "We assist clients with organizing information and preparing required forms for submission to licensed professionals.",
    icon: step2,
  },

  {
    step: "Step 5",
    title: "Negotiation & Mediation Support:",
    desc: "Facilitating discussions to help clients achieve the best possible legal outcomes.",
    icon: step3,
  },
  {
    step: "Step 6",
    title: "Translation Services:",
    desc: "Translation services ensure accurate communication across languages, reduce misunderstandings, support legal and official compliance, and enable effective interaction with authorities and institutions.",
    icon: step1,
  },

];

const OnlineVisa = () => {
  return (
    <section className="pt-20">
      <div className="max-w-7xl mx-auto px-4">
        {/* TOP CONTENT */}
        <div className="grid md:grid-cols-2 gap-10 mb-16">
          <div>
            <p className="text-sm uppercase tracking-widest font-semibold text-gray-500 mb-3">
              HOW WE HELP CLIENTS
            </p>
            <h2 className="text-3xl md:text-5xl pr-8 font-bold text-gray-900 capitalize leading-tight mb-4">
              What We Do

            </h2>
            <div className="flex gap-2">
              <div className="w-12 h-1 bg-[#ec4e4f] "></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
            </div>
          </div>

          <p className="text-xl md:text-[19px] text-[#555555] leading-relaxed">
            We offer expert immigration support through a dedicated team of qualified consultants, committed to
            guiding you towards the best possible outcome for your case.


          </p>
        </div>
      </div>

      {/* STEPS SECTION */}
      <div className="relative">
        <div className="max-w-7xl mx-auto px-4 pt-15 pb-20">
          <div className="grid md:grid-cols-3 gap-12 relative">

            {stepsData.map((item, index) => (
              <div key={index} className="relative pr-[30px]">

                {/* STEP LABEL */}
                {/* <p className="text-sm font-semibold text-[#2d5883] mb-4">
                  {item.step}
                </p> */}

                {/* ICON CIRCLE */}
                <div className="relative mb-6 w-28 h-28 overflow-hidden rounded-full border border-dashed border-[#2d5883] flex items-center justify-center">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="w-full h-full p-3"
                  />
                </div>
                {/* CONTENT */}
                <h3 className="text-[26px] font-semibold  text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-[#555555] text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlineVisa;
